/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Sign_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Sign the NDA?" |
*
* @param {Nda_Sign_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_sign_confirm_title = /** @type {((inputs?: Nda_Sign_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Sign_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Signer le NDA ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Firmar el NDA?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assinar o NDA?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Firmare l'NDA?")
	return /** @type {LocalizedString} */ ("Sign the NDA?")
});